<template>
    <input v-model="model"
           class="form-control"
           :class="{ 'is-invalid' : hasError, 'form-control-lg': !small }"
           :id="uniqueId"
           :style="hasError ? { 'border-width': '1px' } : {}"
           v-mask="mask"
    />
</template>

<script>
    import { mask } from 'vue-the-mask'

    export default {
        name: 'Input',
        props: {
            value: [ String, Number ],
            mask: {
                type: String,
                default: ''
            },
            hasError: Boolean,
            small: Boolean,
            focus: Boolean
        },
        computed:{
            model: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('input', val)
                }
            },
            uniqueId: function() {
                return 'uid-' + this._uid
            }
        },
        directives: {
            mask(el, binding) {
                binding.value ? mask(el, binding) : (el.oninput = null)
            }
        },
        methods: {
            focusInput() {
                let element = document.getElementById(this.uniqueId)
                if (element) {
                    element.focus();
                }
            }
        },
        watch: {
            focus: {
                immediate: true,
                handler(val) {
                    if (val) {
                        setTimeout(() => {
                            this.$nextTick(() => this.focusInput());
                        }, 200);
                    }
                }
            }
        }
    }
</script>
